import * as React from 'react'

import type { Form } from 'factorial-form'
import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import MonthPicker from 'modules/core/components/Inputs/MonthPicker'

import type { WizardData } from 'modules/payroll_bundle/pages/SelfServicePage/types'
import { MONTHLY } from 'modules/payroll_bundle/store/models/Policy'

interface Props {
  form: Form
  label: string
  readonly?: boolean
  periodicity: string | undefined
  enableDay: (date: Date | moment.Moment) => boolean
  data?: WizardData
}

const StartsOnDatePicker = ({ label, periodicity, readonly, enableDay, form, data }: Props) => {
  if (periodicity === MONTHLY) {
    if (form.get('starts_on').value === '') {
      form.setValues({
        starts_on: moment().startOf('month').format('YYYY-MM-DD'),
      })
    }

    return (
      <MonthPicker
        readonly={readonly}
        label={label}
        field={form.get('starts_on')}
        value={form.get('starts_on').value}
      />
    )
  }

  return (
    <DayPicker
      enableDay={enableDay}
      label={label}
      readonly={readonly}
      field={form.get('starts_on')}
      value={form.get('starts_on').value}
    />
  )
}

export default observer(StartsOnDatePicker)
